module.exports = __webpack_public_path__ + "static/m_solution16-0f63ceddf7782305d2dec08ef49c126b.png";